import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'accent';
  className?: string;
}

const variants: Record<string, string> = {
  primary: 'bg-primary text-primary-foreground hover:brightness-110',
  secondary: 'bg-secondary text-foreground hover:brightness-95 border',
  ghost: 'bg-transparent text-foreground hover:bg-muted',
  accent: 'bg-accent text-white hover:brightness-110',
};

export default function Button({
  children,
  variant = 'primary',
  className = '',
  ...rest
}: Props) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer transition ${variants[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}